import { render, staticRenderFns } from "./HospitalDoctorsTable.vue?vue&type=template&id=062ee7d6"
import script from "./HospitalDoctorsTable.vue?vue&type=script&lang=js"
export * from "./HospitalDoctorsTable.vue?vue&type=script&lang=js"
import style0 from "./HospitalDoctorsTable.vue?vue&type=style&index=0&id=062ee7d6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports